import React from 'react';

import { FormattedMessage } from 'react-intl';

import TextInput from '../../components/TextInput';
import PhoneNumberInput from '../../components/PhoneNumberInput';
import CountrySwitcher from '../../components/CountrySwitcher';

import { formMessages } from '../../defineMessages';

export const redeemBillingFields = deliveryMethods => {
  const billingFields = {
    personal: [
      {
        label: 'fullName',
        name: 'name',
        autoComplete: 'section-billing name',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
    ],
    contact: [
      {
        label: 'email',
        name: 'email',
        autoComplete: 'section-billing email',
        component: TextInput,
        type: 'email',
        required: true,
        responsive: {
          xs: 24,
        },
      },
    ],
    address: [
      {
        label: 'country',
        name: 'countryCode',
        autoComplete: 'section-billing country',
        component: CountrySwitcher,
        basic: true,
        showLabel: true,
        required: true,
        fluid: true,
        responsive: {
          xs: 24,
        },
      },
    ],
  };

  if (deliveryMethods.includes('Sms') || deliveryMethods.includes('Physical')) {
    billingFields.contact[0].responsive = {
      xs: 24,
      md: 12,
    };

    billingFields.contact.push({
      label: 'phoneNumber',
      name: 'phone',
      autoComplete: 'section-billing tel',
      component: PhoneNumberInput,
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    });
  }

  if (deliveryMethods.includes('Physical')) {
    billingFields.address[0].responsive = {
      xs: 24,
      md: 8,
    };

    billingFields.address = [
      {
        label: 'address',
        name: 'line1',
        placeholder: formMessages.line1,
        autoComplete: 'section-billing address-line1',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'address',
        showLabel: false,
        name: 'line2',
        placeholder: formMessages.line2,
        autoComplete: 'section-billing address-line2',
        component: TextInput,
        type: 'text',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'attention',
        name: 'attention',
        autoComplete: 'section-billing attention',
        component: TextInput,
        type: 'text',
        required: false,
        responsive: {
          xs: 24,
        },
      },
      {
        label: 'postCode',
        name: 'postCode',
        autoComplete: 'section-billing postal-code',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
          md: 8,
        },
      },
      {
        label: 'city',
        name: 'city',
        autoComplete: 'section-billing address-level2',
        component: TextInput,
        type: 'text',
        required: true,
        responsive: {
          xs: 24,
          md: 8,
        },
      },
      ...billingFields.address,
    ];
  }

  return billingFields;
};

export const billingFieldsets = {
  personal: [
    {
      label: 'fullName',
      name: 'name',
      autoComplete: 'section-billing name',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
      },
    },
  ],
  address: [
    {
      label: 'address',
      name: 'line1',
      placeholder: formMessages.line1,
      autoComplete: 'section-billing address-line1',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
      },
    },
    {
      label: 'address',
      showLabel: false,
      name: 'line2',
      placeholder: formMessages.line2,
      autoComplete: 'section-billing address-line2',
      component: TextInput,
      type: 'text',
      required: false,
      responsive: {
        xs: 24,
      },
    },
    {
      label: 'attention',
      name: 'attention',
      autoComplete: 'section-billing attention',
      component: TextInput,
      type: 'text',
      required: false,
      responsive: {
        xs: 24,
      },
    },
    {
      label: 'postCode',
      name: 'postCode',
      autoComplete: 'section-billing postal-code',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
    {
      label: 'city',
      name: 'city',
      autoComplete: 'section-billing address-level2',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
    {
      label: 'country',
      name: 'countryCode',
      autoComplete: 'section-billing country',
      component: CountrySwitcher,
      basic: true,
      showLabel: true,
      required: true,
      fluid: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
  ],
  contact: [
    {
      label: 'phoneNumber',
      name: 'phone',
      autoComplete: 'section-billing tel',
      component: PhoneNumberInput,
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'email',
      name: 'email',
      autoComplete: 'section-billing email',
      component: TextInput,
      type: 'email',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
  ],
};
export const recipientFields = {
  Physical: [
    {
      label: 'fullName',
      name: 'recipientName',
      autoComplete: 'section-recipient name',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'attention',
      name: 'attention',
      autoComplete: 'section-recipient attention',
      component: TextInput,
      type: 'text',
      required: false,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'address',
      name: 'line1',
      placeholder: formMessages.line1,
      autoComplete: 'section-recipient address-line1',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
      },
    },
    {
      label: 'address',
      showLabel: false,
      name: 'line2',
      placeholder: formMessages.line2,
      autoComplete: 'section-recipient address-line2',
      component: TextInput,
      type: 'text',
      required: false,
      responsive: {
        xs: 24,
      },
    },
    {
      label: 'postCode',
      name: 'postCode',
      autoComplete: 'section-recipient postal-code',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
    {
      label: 'city',
      name: 'city',
      autoComplete: 'section-recipient address-level2',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
    {
      label: 'country',
      name: 'countryCode',
      autoComplete: 'section-recipient country',
      component: CountrySwitcher,
      basic: true,
      showLabel: true,
      required: true,
      fluid: true,
      responsive: {
        xs: 24,
        md: 8,
      },
    },
    {
      label: 'email',
      name: 'recipientEmail',
      autoComplete: 'section-recipient email',
      component: TextInput,
      type: 'email',
      required: false,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'phoneNumber',
      name: 'recipientPhone',
      autoComplete: 'section-recipient tel',
      component: PhoneNumberInput,
      type: 'tel',
      required: false,
      invalidPhoneNumberMessage: (
        <FormattedMessage {...formMessages.invalidPhoneNumber} />
      ),
      responsive: {
        xs: 24,
        md: 12,
      },
    },
  ],
  Email: [
    {
      label: 'fullName',
      name: 'recipientName',
      autoComplete: 'section-recipient name',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'email',
      name: 'recipientEmail',
      autoComplete: 'section-recipient email',
      component: TextInput,
      type: 'email',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'emailRepeat',
      name: 'recipientEmailRepeat',
      autoComplete: 'section-recipient email',
      component: TextInput,
      type: 'email',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
  ],
  Sms: [
    {
      label: 'fullName',
      name: 'recipientName',
      autoComplete: 'section-recipient name',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'phoneNumber',
      name: 'recipientPhone',
      autoComplete: 'section-recipient tel',
      component: PhoneNumberInput,
      type: 'tel',
      required: true,
      invalidPhoneNumberMessage: (
        <FormattedMessage {...formMessages.invalidPhoneNumber} />
      ),
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'phoneNumberRepeat',
      name: 'recipientPhoneRepeat',
      autoComplete: 'section-recipient tel',
      component: PhoneNumberInput,
      type: 'tel',
      required: true,
      invalidPhoneNumberMessage: (
        <FormattedMessage {...formMessages.invalidPhoneNumber} />
      ),
      responsive: {
        xs: 24,
        md: 12,
      },
    },
  ],
  CsvByEmail: [
    {
      label: 'fullName',
      name: 'recipientName',
      autocomplete: 'section-recipient name',
      component: TextInput,
      type: 'text',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
    {
      label: 'email',
      name: 'recipientEmail',
      autocomplete: 'section-recipient email',
      component: TextInput,
      type: 'email',
      required: true,
      responsive: {
        xs: 24,
        md: 12,
      },
    },
  ],
};
